import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    // Here we are adding all custom mat icons in the registry
    constructor(private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer,
                private renderer: Renderer2,
                private el: ElementRef) {
        this.matIconRegistry.addSvgIcon(
            `design_mode`,
            this.domSanitizer.bypassSecurityTrustResourceUrl(environment.clientRoot + 'assets/svg/design-mode.svg')
        );
    }

    ngOnInit(): void {
    }

    detectPhoneAndAct() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            this.renderer.addClass(this.el.nativeElement, 'ios');
        }
    }

}